export default __webpack_public_path__ + "static/media/aspas.3c25c306.svg";